import get from 'lodash/get'
import { deserializeTeam, fetchTeamBySlug } from 'supporticon/api/teams'
import { createAction } from 'supporticon/utils/actions'
import { createReducer } from 'supporticon/utils/reducers'
import { selectCustomSupporterPage } from '../customSupporterPages'
import { selectAPIParams } from '../site'

// Constants
const NAMESPACE = 'app/teams'

// Selectors
export * from './selectors'

// Action
export const fetchTeam = slug => (dispatch, getState) => {
  const state = getState()
  const { apiParams } = selectAPIParams(state)
  const customSupporterPage = selectCustomSupporterPage(state)

  return dispatch(createAction({
    namespace: NAMESPACE,
    fetcher: fetchJGTeam(slug, { ...apiParams, ...customSupporterPage })
  }))
}

const fetchJGTeam = (slug, params = {}) =>
  fetchTeamBySlug(slug, {
    includeFitness: true,
    includePages: true,
    fitnessParams: {
      startDate: params.startDateTime,
      endDate: params.endDateTime
    }
  })
    .then(team => ({ ...params, ...team }))

const sumTeamMembersRaised = team =>
  get(team, 'members', []).reduce((acc, { raised }) => acc + raised, 0)

const customDeserializeTeam = data => {
  const team = deserializeTeam(data)

  return {
    ...team,
    raised: data.includeTeamsOffline
      ? Math.max(team.raised, sumTeamMembersRaised(team))
      : team.raised,
    url: `/teams/${team.slug}`
  }
}

// Reducer
export default createReducer({
  namespace: NAMESPACE,
  deserialize: customDeserializeTeam
})
